
import { SlashNConverter } from '@/utils'
export default {
    props: {
        conData: {
            type: [String, Object, Array],
        },
    },
    data() {
        return {
            componentKey: 0,
            content: '',
        }
    },
    watch: {
        conData() {
            console.log(Array.isArray(this.conData))
            this.content = SlashNConverter(
                Array.isArray(this.conData)
                    ? this.conData[0].content
                    : this.conData.content
            )
            console.log('updated')
            // console.log(this.conData[0].content)
            // rerender 문제 해결 방법
            this.forceRerender()
        },
    },
    methods: {
        // triangleSpliter(target) {
        //     if (target !== undefined) {
        //         const TRegexp = /(?=▷)/g
        //         const splitStr = target.split(TRegexp)
        //         return splitStr
        //     }
        // },
        // 하위 컴포넌트 렌더링 문제
        forceRerender() {
            this.componentKey += 1
        },
    },
}
